export const STRINGS = {
  FORCEPASSWORD_ERROR_CODE: "forcepasswordchangenotice",
};
